/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CustomerTrxController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TransactionDto } from "../models";

@Injectable({ providedIn: "root" })
export class CustomerTrxControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    findCustomerTransactions(username: string, fromDate?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TransactionDto>>;
    findCustomerTransactions(username: string, fromDate?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TransactionDto>>>;
    findCustomerTransactions(username: string, fromDate?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TransactionDto>>>;
    findCustomerTransactions(username: string, fromDate?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/customers/transactions/${username}`;

        let params = new HttpParams();
        if (fromDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, fromDate, 'fromDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
